import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import ExerChoice from "./ExerChoice";
import Tabs from "./Tabs";
import TabPane from "./TabPane";

import StartExerChapter from "./StartExerChapter"
import StartExerQuestionStore from "./StartExerQuestionStore";
import StartExerExam from "./StartExerExam";
export class StartExer extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    defaultActiveKey: 0,
    disabled: false,
  }
  componentWillMount() {
    let { pathname } = this.props.history.location;
    pathname = pathname.slice(pathname.lastIndexOf('/') + 1, pathname.length);
    this.setState({
      defaultActiveKey: parseInt(pathname, 10),
    })
  }
  updateRouter(activeKey) {
    this.props.history.replace(`/center/startExer/${activeKey}`)
  }
  setChoiceDisable(disabled) {
    this.setState({
      disabled,
    })
  }
  render() {
    const { defaultActiveKey, disabled } = this.state;
    return (
      <div className="center-start-exer">
        <ExerChoice disabled={disabled} {...this.props} />
        <div className="tabs">
          <Tabs
            {...this.props}
            defaultActiveKey={defaultActiveKey}
            onTabsChange={(activeKey) => {
              this.setState({
                defaultActiveKey: activeKey
              });
              if (activeKey === 1 || 2) {
                this.setState({
                  disabled: false,
                })
              }
              this.updateRouter(activeKey);
            }}
            tabs={[{ Name: "章节练习" }, { Name: "历年真题" }, { Name: "模拟考试" }]}
          />
        </div>
        <TabPane {...this.props} defaultActiveKey={defaultActiveKey}>
          <StartExerChapter setChoiceDisable={this.setChoiceDisable.bind(this)} {...this.props} />
          <StartExerQuestionStore {...this.props} />
          <StartExerExam {...this.props} />
        </TabPane>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StartExer);



// WEBPACK FOOTER //
// ./src/features/center/StartExer.js